import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Busca, Pacote, TIPOBUSCAAEREO, Trecho } from 'src/app/model';
import { AeroportoService, CidadeService } from 'src/app/services';
import { CarroService } from 'src/app/services/turismo/carro.service';
import { PacotelstService } from 'src/app/services/turismo/pacotelst.service';
import { addOrSubtractDays, diffInDays, formatDateTime, toDateTime } from 'src/app/utils/luxon.helper';

@Component({
    selector: 'app-rebusca',
    templateUrl: './rebusca.component.html',
    styleUrls: ['./rebusca.component.scss'],
    standalone: false
})
export class RebuscaComponent implements OnInit, AfterViewInit {

    TIPOBUSCAAEREO: typeof TIPOBUSCAAEREO = TIPOBUSCAAEREO;
    @Input() busca: Busca;
    @Input() tipoBusca;

    @Output() atualizarNrNoites = new EventEmitter<number>();
    @Output() rebuscou = new EventEmitter<any>();
    @Output() setDataIdaEmitter = new EventEmitter<any>();
    @Output() setDataVoltaEmitter = new EventEmitter<any>();

    cidades = [];
    lojas = [];
    minDataVolta: any;

    //CIRCUITO
    Fornecedores: string[] = ["ST"];
    FiltroCircuito: string[] = ["ST"];
    Temporadas: string[] = [];

    constructor(
        private aeroportoService: AeroportoService,
        private cidadeService: CidadeService,
        private cdr: ChangeDetectorRef,
        private router: Router,
        private route: ActivatedRoute,
    ) {
    }

    ngOnInit() { 
        if (this.Temporadas.length == 0) {
            this.Temporadas.push(formatDateTime(addOrSubtractDays(new Date(), {years : -1}).toISO(), "yyyy"));
            this.Temporadas.push(formatDateTime(new Date(), "yyyy"));
            this.Temporadas.push(formatDateTime(addOrSubtractDays(new Date(), {years : 1}).toISO(), "yyyy"));
        }
    }

    ngAfterViewInit() {
        this.cdr.detectChanges();
        if (this.busca.tipoBusca.beto &&
            !(this.busca.tipoBusca.aereo ||
                this.busca.tipoBusca.carro ||
                this.busca.tipoBusca.hotel ||
                this.busca.tipoBusca.produtooffline ||
                this.busca.tipoBusca.seguro ||
                this.busca.tipoBusca.servicoExclusivo ||
                this.busca.tipoBusca.transfer ||
                this.busca.tipoBusca.ticket
            )) {
            this.busca.trechos[0].dataIda = this.getAmanha()
            this.busca.trechos[0].dataVolta = addOrSubtractDays(this.getAmanha(), { days: 365 });
        }
    }

    setDataIdaRebusca(event: any, trechos: Trecho[], indice: number = 0) {
        this.setDataIdaEmitter.emit({ event, trechos, indice });
    }

    setDataVoltaRebusca(event: any, trechos: Trecho[], indice: number = 0) {
        this.setDataVoltaEmitter.emit({ event, trechos, indice });
    }

    timerCidade = null;
    buscaCidadeDebounce(val: string) {
        clearTimeout(this.timerCidade);
        this.timerCidade = setTimeout(() => {
            this.buscaDados(val);
        }, 600);
    }

    buscaDados(val: string) {
        if (this.tipoBusca == 'aereo') {
            this.aeroportoService.buscarPorParametro(val, 1).subscribe(
                dados => {
                    this.cidades = dados.Items.map(x => {
                        x.display_field = `${x.Iata} - ${x.Descricao} / ${x.Cidade.Nome} - ${x.Cidade.Estado.Iata} / ${x.Cidade.Estado.Pais.Iata}`;
                        return x;
                    });
                },
                erro => {
                    console.log(erro);
                    this.cidades = [];
                }
            );
        } else {
            this.cidadeService.buscarOrcamento(val, 1).subscribe(
                dados => {
                    this.cidades = dados.Items.map(x => {
                        x.display_field =
                            x.Nome + " - " + x.Estado.Nome + " / " + x.Estado.Pais.Nome;
                        return x;
                    });
                },
                erro => {
                    console.log(erro);
                    this.cidades = [];
                }
            );
        }
    }

    selecionaCidadeOrigem(item, trecho) {
        if (this.tipoBusca == 'aereo') {
            trecho.AeroportoPartida = item;
            trecho.cidadeOrigem = item.Cidade;
        } else {
            trecho.cidadeOrigem = item;
        }
    }

    selecionaCidadeDestino(item, trecho) {
        if (this.tipoBusca == 'aereo') {
            trecho.AeroportoChegada = item;
            trecho.cidadeDestino = item.Cidade;
            trecho.cidadeDestino.display_field =
                trecho.cidadeDestino.Nome +
                " - " +
                trecho.cidadeDestino.Estado.Nome +
                " / " +
                trecho.cidadeDestino.Estado.Pais.Nome;
        } else {
            trecho.cidadeDestino = item;
        }
    }

    buscou() {
        if (this.tipoBusca == 'carro') {
            this.busca.trechos[0].dataIda = this.busca.dataOrigem
            this.busca.trechos[0].dataVolta = this.busca.dataDevolucao;
        } else {
            this.busca.dataOrigem = this.busca.dataOrigem;
            this.busca.dataDevolucao = this.busca.dataDevolucao;
        }

        this.rebuscou.emit(this.busca);
    }

    expandirAccordion: boolean = true;
    expandir() {
        this.expandirAccordion = !this.expandirAccordion;
    }

    getAmanha() {
        let data = toDateTime(new Date());
        data = data.plus({ days: 1 });
        return data;
    }

    voltar() {
        this.router.navigate(['../'], { relativeTo: this.route });
    }

    addOneYear(year: string): string {
        return (Number.parseInt(year) + 1).toString();
    }
    
    circuitoSelecionado(circuito) {
        return this.FiltroCircuito.indexOf(circuito) >= 0;
    }
    selecionarCircuito(circuito) {
        if (this.circuitoSelecionado(circuito)) {
            this.FiltroCircuito = this.FiltroCircuito.filter(x => x != circuito);
        } else {
            this.FiltroCircuito.push(circuito);
        }
    } 
}
